import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import APIFunction from "../util/api";

export default function ActivateAccount() {
  const [status, setStatus] = useState("loading"); // "loading" | "success" | "error"
  const [message, setMessage] = useState("");
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Invalid activation link.");
      return;
    }

    const activateUser = async () => {
      try {
        await APIFunction.activateRequest(token)

        setStatus("success");
        setMessage("Your account has been activated! 🎉 Redirecting to login...");
      } catch (err) {
        console.error(err);
        setStatus("error");
        setMessage(err.message || "Activation failed. Link may have expired or invalid");
      }
    };

    activateUser();
  }, [searchParams]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="bg-white p-6 rounded-2xl shadow-md text-center w-full max-w-md">
        {status === "loading" && <p>Activating your account... 🔄</p>}
        {status === "success" && <p className="text-green-600">{message}</p>}
        {status === "error" && <p className="text-red-600">{message}</p>}
      </div>
    </div>
  );
}
